import { ProjectStateStatusEnum } from '@/app/api';
import { useMemo } from 'react';

export const useIsProjectActive = (status: ProjectStateStatusEnum) => {
  return useMemo(
    () =>
      !([ProjectStateStatusEnum.Finished, ProjectStateStatusEnum.Closed] as ProjectStateStatusEnum[]).includes(status),
    [status],
  );
};
